import(/* webpackMode: "eager" */ "/home/runner/work/bullseye/bullseye/apps/prospector/app/(unauthed)/(locations)/buffalo/page.tsx");
